module.exports = __webpack_public_path__ + "img/servicos.a1e76d0c.svg";